export enum CreateProjectSource {
	BlankProject = 'BlankProject',
	UseTemplate = 'UseTemplate',
	WMTemplate = 'WMTemplate',
}

export enum MenuActionType {
	CreateBlank = 'createBlank',
	CreateFromTemplate = 'createFromTemplate',
}

export enum tab {
	home = 'home',
	files = 'files',
}
